module.exports = __webpack_public_path__ + "media/Bird3.84da39ac.ogg";